import { ThemeColors } from '../../../web/components-v2/Theme/theme';

type PillColor = keyof ThemeColors['pill'];

const PILL_HUES: { maxHue: number; color: PillColor }[] = [
	{ maxHue: 15, color: 'red' },
	{ maxHue: 45, color: 'orange' },
	{ maxHue: 65, color: 'yellow' },
	{ maxHue: 160, color: 'green' },
	{ maxHue: 195, color: 'teal' },
	{ maxHue: 255, color: 'blue' },
	{ maxHue: 290, color: 'purple' },
	{ maxHue: 345, color: 'pink' },
	{ maxHue: 360, color: 'red' },
];

export function hexToPillColor(hexColor?: string): PillColor {
	const match = /^#?([0-9a-f]{6})$/i.exec(hexColor?.trim() ?? '');
	if (!match) {
		return 'gray';
	}
	const [r, g, b] = [0, 2, 4].map(offset => parseInt(match[1].slice(offset, offset + 2), 16) / 255);
	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	const delta = max - min;
	const lightness = (max + min) / 2;
	const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
	if (saturation < 0.2) {
		return 'gray';
	}
	let hue = max === r ? ((g - b) / delta) % 6 : max === g ? (b - r) / delta + 2 : (r - g) / delta + 4;
	hue = (hue * 60 + 360) % 360;
	return PILL_HUES.find(({ maxHue }) => hue < maxHue)?.color ?? 'red';
}
